import { type Node as ProseMirrorNode } from '@tiptap/pm/model';

/**
 * Counts the number of words in a given text string.
 * Words are split by whitespace and empty strings are filtered out.
 */
export const getWordCount = (text: string): number => {
  return text
    .trim()
    .split(/\s+/)
    .filter((word) => word.length > 0).length;
};

/**
 * Calculates word counts for a selection within a ProseMirror document.
 * @param doc - The ProseMirror document node
 * @param from - Start position of the selection
 * @param to - End position of the selection
 * @returns Object containing selectedWordCount and totalWordCount
 */
export const getSelectionWordCounts = (
  doc: ProseMirrorNode,
  from: number,
  to: number
): { selectedWordCount: number; totalWordCount: number } => {
  const selectedText = doc.textBetween(from, to);
  const selectedWordCount = getWordCount(selectedText);
  const totalText = doc.textContent;
  const totalWordCount = getWordCount(totalText);

  return { selectedWordCount, totalWordCount };
};
